// extracted by mini-css-extract-plugin
export default {"sectionHeader":"SpecialEntitySection_sectionHeader__54EbU","dueDiligenceEntityCardSection":"SpecialEntitySection_dueDiligenceEntityCardSection__8ATtX"};